<div data-test="main-search" class="search-panel" [ngClass]="{ filled: searchInput.value.length }">
  <label
    data-test="main-search--label"
    class="searchbox" [class.dirty]="!!searchInput.value"
  >
    <input
      data-test="main-search--input"
      #searchInput
      autocomplete="off"
      aria-describedby="initialDescription"
      aria-controls="results"
      aria-autocomplete="both"
      value="{{ chosenWord }}"
      [placeholder]="'dpSearchBox.placeholder' | cxTranslate"
      [attr.aria-label]="'dpSearchBox.placeholder' | cxTranslate"
      (focus)="onFocus()"
      (blur)="onBlur($event)"
      (click)="open()"
      (input)="search(searchInput.value)"
      (keydown.escape)="close($event)"
      (keydown.enter)="onSearchInputKeydownEnter($event)"
      (keydown.arrowup)="focusPreviousChild($event)"
      (keydown.arrowdown)="focusNextChild($event)"
    />

    <button
      data-test="main-search--btn-reset"
      class="btn reset"
      [attr.aria-label]="'common.reset' | cxTranslate"
      (mousedown)="clear(searchInput)"
      (keydown.enter)="clear(searchInput)"
    >
      <mat-icon class="close-icon" svgIcon="close"></mat-icon>
    </button>

    <button
      data-test="main-search-btn-search"
      class="btn search"
      [attr.aria-label]="'dpSearchBox.placeholder' | cxTranslate"
      (click)="onSearchInputKeydownEnter($event)"
    >
      <mat-icon class="icon" svgIcon="search"></mat-icon>
    </button>
  </label>
  <div class="mobile-toggle" data-test="main-search--mobile-toggle">
    <button
      data-test="main-search--close-btn"
      class="btn toggle" (click)="close($event, true)" [attr.aria-label]="'common.close' | cxTranslate"
    >
      <mat-icon class="icon" svgIcon="close"></mat-icon>
    </button>
  </div>
  <div
    data-test="main-search--results"
    class="results"
    id="results"
    role="listbox"
    *ngIf="results$ | async as results"
    (click)="close($event, true)"
    [ngClass]="{
            hidden: !focused,
            'non-empty': isResultsListEmpty(results)
        }"
  >
    <div
      data-test="main-search--results-message"
      class="message"
      *ngIf="results.message"
      [innerHTML]="results.message"
    ></div>
    @if (results?.products.length) {
      <ul
        data-test="main-search--results-products"
        class="products"
        tabindex="0"
        [attr.aria-label]="'dpSearchBox.ariaLabelProducts' | cxTranslate"
      >
        @for (product of results?.products; let i = $index; track product?.code) {

          <li
            [attr.data-test]="'main-search--results-' + product?.code"
            class="product"
            [class.has-media]="config.displayProductImages"
            (blur)="close($event)"
            (keydown.arrowup)="focusPreviousChild($event)"
            (keydown.arrowdown)="focusNextChild($event)"
            (keydown.enter)="close($event, true)"
            (keydown.escape)="close($event, true)"
            (mousedown)="clickOnProduct(searchInput.value, product, i)"
          >
            <dp-searched-product [product]="product" />
          </li>
        }
      </ul>
    }
  </div>
</div>
